{
  "about.blocks": "Модерацияланған серверлер",
  "about.contact": "Байланыс:",
  "about.default_locale": "Әдепкі",
  "about.disclaimer": "Mastodon деген тегін, бастапқы коды ашық бағдарламалық жасақтама және Mastodon gGmbH-тің сауда маркасы.",
  "about.domain_blocks.no_reason_available": "Себеп қолжетімсіз",
  "about.domain_blocks.preamble": "Mastodon әдетте сізге Fediverse'тің кез келген серверінің қолданушыларының контентін көріп, олармен байланысуға мүмкіндік береді. Осы белгілі серверде жасалған ережеден тыс жағдайлар міне.",
  "about.domain_blocks.silenced.explanation": "Сіз бұл сервердің профильдері мен контентін іздегенше немесе жазылмағанша, оларды әдетте көрмейсіз.",
  "about.domain_blocks.silenced.title": "Шектеулі",
  "about.domain_blocks.suspended.explanation": "Бұл сервердің деректері өңделмейді, сақталмайды және айырбасталмайды, сондықтан бұл сервердің қолданушыларымен кез келген әрекеттесу немесе байланыс мүмкін емес.",
  "about.domain_blocks.suspended.title": "Тоқтатылған",
  "about.language_label": "Тіл",
  "about.not_available": "Бұл ақпарат бұл серверде қолжетімді емес.",
  "about.powered_by": "{mastodon} негізіндегі орталықсыз әлеуметтік желі",
  "about.rules": "Сервер ережелері",
  "account.add_or_remove_from_list": "Тізімге қосу немесе жою",
  "account.badges.bot": "Бот",
  "account.badges.group": "Топ",
  "account.block": "@{name} дегенді бұғаттау",
  "account.block_domain": "{domain} доменін бұғаттау",
  "account.block_short": "Бұғаттау",
  "account.blocked": "Бұғатталған",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.direct": "@{name} жеке айту",
  "account.disable_notifications": "@{name} постары туралы ескертпеу",
  "account.edit_profile": "Профильді өңдеу",
  "account.edit_profile_short": "Түзеу",
  "account.enable_notifications": "@{name} постары туралы ескерту",
  "account.endorse": "Профильде ұсыну",
  "account.familiar_followers_many": "{name1}, {name2} және {othersCount, plural, one {сіз білетін тағы бір адам} other {сіз білетін тағы # адам}} жазылған",
  "account.familiar_followers_one": "{name1} жазылған",
  "account.familiar_followers_two": "{name1} мен {name2} жазылған",
  "account.featured": "Ерекшеленген",
  "account.featured.accounts": "Профильдер",
  "account.follow": "Жазылу",
  "account.follow_back": "Кері жазылу",
  "account.followers": "Жазылушы",
  "account.followers.empty": "Бұл қолданушыға әлі ешкім жазылмаған.",
  "account.followers_counter": "{count, plural, one {{counter} жазылушы} other {{counter} жазылушы}}",
  "account.following": "Жазылым",
  "account.following_counter": "{count, plural, one {{counter} жазылған} other {{counter} жазылған}}",
  "account.follows.empty": "Бұл қолданушы әлі ешкімге жазылмаған.",
  "account.follows_you": "Сізге жазылған",
  "account.go_to_profile": "Профиліне өту",
  "account.hide_reblogs": "@{name} бустарын жасыру",
  "account.in_memoriam": "Естелік ретінде.",
  "account.joined_short": "Қосылған",
  "account.languages": "Жазылған тілдерді өзгерту",
  "account.link_verified_on": "Сілтеме меншігі расталған күн {date}",
  "account.locked_info": "Бұл қолданушы өзі туралы мәліметтерді жасырған. Тек жазылғандар ғана көре алады.",
  "account.media": "Медиа",
  "account.mention": "@{name} дегенді атау",
  "account.moved_to": "{name} өзінің жаңа аккаунты енді мынау екенін көрсетті:",
  "account.mute": "@{name} дегенді елемеу",
  "account.mute_notifications_short": "Хабарландыруларды өшіру",
  "account.mute_short": "Өшіру",
  "account.muted": "Еленбейді",
  "account.mutual": "Сіздер бір-біріңізге жазылғансыздар",
  "account.no_bio": "Сипаттама берілмеген.",
  "account.open_original_page": "Бастапқы бетті ашу",
  "account.posts": "Пост",
  "account.remove_from_followers": "{name} жазылушылардан жою",
  "account.report": "Шағымдану @{name}",
  "account.requested_follow": "{name} сізге жазылуға сұраныс жіберді",
  "account.share": "@{name} профилін бөлісу\"",
  "account.show_reblogs": "@{name} бөліскендерін көрсету",
  "account.statuses_counter": "{count, plural, one {{counter} жазба} other {{counter} жазба}}",
  "account.unblock": "Бұғаттан шығару @{name}",
  "account.unblock_domain": "Бұғаттан шығару {domain}",
  "account.unblock_domain_short": "Бұғаттауды алу",
  "account.unblock_short": "Бұғаттауды алу",
  "account.unendorse": "Профильде рекомендемеу",
  "account.unfollow": "Оқымау",
  "account.unmute": "@{name} ескертпелерін қосу",
  "account.unmute_notifications_short": "Хабарландыруларды қосу",
  "account.unmute_short": "Қосу",
  "account_note.placeholder": "Жазба қалдыру үшін бас",
  "admin.dashboard.daily_retention": "Тіркелгеннен кейінгі күн бойынша пайдаланушыларды сақтау көрсеткіші",
  "admin.dashboard.monthly_retention": "Тіркелгеннен кейінгі ай бойынша пайдаланушыларды сақтау көрсеткіші",
  "admin.dashboard.retention.average": "Орташа",
  "admin.dashboard.retention.cohort": "Тіркелу айы",
  "admin.dashboard.retention.cohort_size": "Жаңа пайдаланушылар",
  "admin.impact_report.instance_accounts": "Бұл жоятын аккаунт профильдері",
  "admin.impact_report.instance_followers": "Біздің пайдаланушылар жоғалтатын жазылушылар",
  "alert.rate_limited.message": "Қайтадан көріңіз  {retry_time, time, medium} кейін.",
  "alert.rate_limited.title": "Бағалау шектеулі",
  "alert.unexpected.message": "Бір нәрсе дұрыс болмады.",
  "alert.unexpected.title": "Өй!",
  "alt_text_badge.title": "Балама мазмұны",
  "alt_text_modal.add_alt_text": "Балама мазмұнды қосу",
  "alt_text_modal.done": "Дайын",
  "announcement.announcement": "Хабарландыру",
  "annual_report.summary.close": "Жабу",
  "boost_modal.combo": "Келесіде өткізіп жіберу үшін басыңыз {combo}",
  "bundle_column_error.retry": "Қайтадан көріңіз",
  "bundle_modal_error.close": "Жабу",
  "bundle_modal_error.retry": "Қайтадан көріңіз",
  "column.blocks": "Бұғатталғандар",
  "column.bookmarks": "Бетбелгілер",
  "column.community": "Жергілікті желі",
  "column.directory": "Профильдерді аралау",
  "column.domain_blocks": "Жасырылған домендер",
  "column.follow_requests": "Жазылу сұранымдары",
  "column.home": "Басты бет",
  "column.lists": "Тізімдер",
  "column.mutes": "Үнсіз қолданушылар",
  "column.notifications": "Ескертпелер",
  "column.pins": "Жабыстырылған жазбалар",
  "column.public": "Жаһандық желі",
  "column_back_button.label": "Артқа",
  "column_header.hide_settings": "Баптауларды жасыр",
  "column_header.moveLeft_settings": "Бағананы солға жылжыту",
  "column_header.moveRight_settings": "Бағананы оңға жылжыту",
  "column_header.pin": "Жабыстыру",
  "column_header.show_settings": "Баптауларды көрсет",
  "column_header.unpin": "Алып тастау",
  "community.column_settings.local_only": "Тек жергілікті",
  "community.column_settings.media_only": "Тек медиа",
  "community.column_settings.remote_only": "Тек сыртқы",
  "compose_form.direct_message_warning_learn_more": "Көбірек білу",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Аккаунтыңыз {locked} емес. Кез келген адам жазылып, сізді оқи алады.",
  "compose_form.lock_disclaimer.lock": "жабық",
  "compose_form.placeholder": "Не бөліскіңіз келеді?",
  "compose_form.poll.duration": "Сауалнама мерзімі",
  "compose_form.poll.switch_to_multiple": "Бірнеше жауап таңдайтындай қылу",
  "compose_form.poll.switch_to_single": "Тек бір жауап таңдайтындай қылу",
  "compose_form.spoiler.marked": "Мәтін ескертумен жасырылған",
  "compose_form.spoiler.unmarked": "Мәтін жасырылмаған",
  "confirmation_modal.cancel": "Қайтып алу",
  "confirmations.block.confirm": "Бұғаттау",
  "confirmations.delete.confirm": "Өшіру",
  "confirmations.delete.message": "Бұл жазбаны өшіресіз бе?",
  "confirmations.delete_list.confirm": "Өшіру",
  "confirmations.delete_list.message": "Бұл тізімді жоясыз ба шынымен?",
  "confirmations.logout.confirm": "Шығу",
  "confirmations.logout.message": "Шығатыныңызға сенімдісіз бе?",
  "confirmations.mute.confirm": "Үнсіз қылу",
  "confirmations.redraft.confirm": "Өшіруді құптау",
  "confirmations.unfollow.confirm": "Оқымау",
  "conversation.delete": "Пікірталасты өшіру",
  "conversation.mark_as_read": "Оқылды деп белгіле",
  "conversation.open": "Пікірталасты қарау",
  "conversation.with": "{names} атты",
  "directory.federated": "Танымал желіден",
  "directory.local": "Тек {domain} доменінен",
  "directory.new_arrivals": "Жаңадан келгендер",
  "directory.recently_active": "Жақында кіргендер",
  "embed.instructions": "Төмендегі кодты көшіріп алу арқылы жазбаны басқа сайттарға да орналастыра аласыз.",
  "embed.preview": "Былай көрінетін болады:",
  "emoji_button.activity": "Белсенділік",
  "emoji_button.custom": "Жеке",
  "emoji_button.flags": "Тулар",
  "emoji_button.food": "Тамақ",
  "emoji_button.label": "Эмодзи қосу",
  "emoji_button.nature": "Табиғат",
  "emoji_button.not_found": "Эмодзи жоқ!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Заттар",
  "emoji_button.people": "Адамдар",
  "emoji_button.recent": "Соңғы",
  "emoji_button.search": "Іздеу...",
  "emoji_button.search_results": "Іздеу нәтижелері",
  "emoji_button.symbols": "Таңбалар",
  "emoji_button.travel": "Саяхат",
  "empty_column.account_timeline": "Жазба жоқ ешқандай!",
  "empty_column.account_unavailable": "Профиль қолжетімді емес",
  "empty_column.blocks": "Ешкімді бұғаттамағансыз.",
  "empty_column.bookmarked_statuses": "Ешқандай жазба Бетбелгілер тізіміне қосылмапты. Қосылғаннан кейін осында жинала бастайды.",
  "empty_column.community": "Жергілікті желі бос. Сіз бастап жазыңыз!",
  "empty_column.domain_blocks": "Бұғатталған домен жоқ.",
  "empty_column.follow_requests": "Әлі ешқандай жазылуға сұранымдар келмеді. Жаңа сұранымдар осында көрінетін болады.",
  "empty_column.hashtag": "Бұндай хэштегпен әлі ешкім жазбапты.",
  "empty_column.home": "Әлі ешкімге жазылмапсыз. Бәлкім {public} жазбаларын қарап немесе іздеуді қолданып көрерсіз.",
  "empty_column.list": "Бұл тізімде ештеңе жоқ.",
  "empty_column.mutes": "Әзірше ешқандай үнсізге қойылған қолданушы жоқ.",
  "empty_column.notifications": "Әзірше ешқандай ескертпе жоқ. Басқалармен араласуды бастаңыз және пікірталастарға қатысыңыз.",
  "empty_column.public": "Ештеңе жоқ бұл жерде! Өзіңіз бастап жазып көріңіз немесе басқаларға жазылыңыз",
  "error.unexpected_crash.explanation": "Кодтағы баг немесе браузердегі қатеден, бұл бет дұрыс ашылмай тұр.",
  "error.unexpected_crash.next_steps": "Бетті жаңартып көріңіз. Егер бұл көмектеспесе, Mastodon желісін басқа браузерден немесе мобиль қосымшадан ашып көріңіз.",
  "errors.unexpected_crash.copy_stacktrace": "Жиынтықты көшіріп ал клипбордқа",
  "errors.unexpected_crash.report_issue": "Мәселені хабарла",
  "follow_request.authorize": "Авторизация",
  "follow_request.reject": "Қабылдамау",
  "generic.saved": "Сақталды",
  "getting_started.heading": "Желіде",
  "hashtag.column_header.tag_mode.all": "және {additional}",
  "hashtag.column_header.tag_mode.any": "немесе {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} болмай",
  "hashtag.column_settings.select.no_options_message": "Ұсыныстар табылмады",
  "hashtag.column_settings.select.placeholder": "Хэштег жазыңыз…",
  "hashtag.column_settings.tag_mode.all": "Осының барлығын",
  "hashtag.column_settings.tag_mode.any": "Осылардың біреуін",
  "hashtag.column_settings.tag_mode.none": "Бұлардың ешқайсысын",
  "hashtag.column_settings.tag_toggle": "Осы бағанға қосымша тегтерді қосыңыз",
  "home.column_settings.show_reblogs": "Бөлісулерді көрсету",
  "home.column_settings.show_replies": "Жауаптарды көрсету",
  "home.hide_announcements": "Анонстарды жасыр",
  "home.show_announcements": "Анонстарды көрсет",
  "intervals.full.days": "{number, plural, one {# күн} other {# күн}}",
  "intervals.full.hours": "{number, plural, one {# сағат} other {# сағат}}",
  "intervals.full.minutes": "{number, plural, one {# минут} other {# минут}}",
  "keyboard_shortcuts.back": "артқа қайту",
  "keyboard_shortcuts.blocked": "бұғатталғандар тізімін ашу",
  "keyboard_shortcuts.boost": "жазба бөлісу",
  "keyboard_shortcuts.column": "бағандардағы жазбаны оқу",
  "keyboard_shortcuts.compose": "пост жазу",
  "keyboard_shortcuts.description": "Сипаттама",
  "keyboard_shortcuts.down": "тізімде төмен түсу",
  "keyboard_shortcuts.enter": "жазбаны ашу",
  "keyboard_shortcuts.federated": "жаңандық желіні ашу",
  "keyboard_shortcuts.heading": "Қысқа кодтар тақтасы",
  "keyboard_shortcuts.home": "жергілікті жазбаларды қарау",
  "keyboard_shortcuts.hotkey": "Ыстық пернелер",
  "keyboard_shortcuts.legend": "осы мазмұнды көрсету",
  "keyboard_shortcuts.local": "жергілікті желіні ашу",
  "keyboard_shortcuts.mention": "авторды атап өту",
  "keyboard_shortcuts.muted": "үнсіздер тізімін ашу",
  "keyboard_shortcuts.my_profile": "профиліңізді ашу",
  "keyboard_shortcuts.notifications": "ескертпелер бағанын ашу",
  "keyboard_shortcuts.open_media": "медианы ашу үшін",
  "keyboard_shortcuts.pinned": "жабыстырылған жазбаларды көру",
  "keyboard_shortcuts.profile": "автор профилін қарау",
  "keyboard_shortcuts.reply": "жауап жазу",
  "keyboard_shortcuts.requests": "жазылу сұранымдарын қарау",
  "keyboard_shortcuts.search": "іздеу",
  "keyboard_shortcuts.spoilers": "CW көрсету/жабу",
  "keyboard_shortcuts.start": "бастапқы бағанға бару",
  "keyboard_shortcuts.toggle_hidden": "жабық мәтінді CW ашу/жабу",
  "keyboard_shortcuts.toggle_sensitivity": "көрсет/жап",
  "keyboard_shortcuts.toot": "жаңа жазба бастау",
  "keyboard_shortcuts.unfocus": "жазба қалдыру алаңынан шығу",
  "keyboard_shortcuts.up": "тізімде жоғары шығу",
  "lightbox.close": "Жабу",
  "lightbox.next": "Келесі",
  "lightbox.previous": "Алдыңғы",
  "lists.delete": "Тізімді өшіру",
  "lists.edit": "Тізімді өңдеу",
  "load_pending": "{count, plural, one {# жаңа нәрсе} other {# жаңа нәрсе}}",
  "navigation_bar.blocks": "Бұғатталғандар",
  "navigation_bar.bookmarks": "Бетбелгілер",
  "navigation_bar.domain_blocks": "Жабық домендер",
  "navigation_bar.filters": "Үнсіз сөздер",
  "navigation_bar.follow_requests": "Жазылуға сұранғандар",
  "navigation_bar.follows_and_followers": "Жазылымдар және оқырмандар",
  "navigation_bar.lists": "Тізімдер",
  "navigation_bar.logout": "Шығу",
  "navigation_bar.mutes": "Үнсіз қолданушылар",
  "navigation_bar.preferences": "Басымдықтар",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} сізге жазылды",
  "notification.follow_request": "{name} сізге жазылғысы келеді",
  "notification.own_poll": "Сауалнама аяқталды",
  "notification.reblog": "{name} жазбаңызды бөлісті",
  "notifications.clear": "Ескертпелерді тазарт",
  "notifications.clear_confirmation": "Шынымен барлық ескертпелерді өшіресіз бе?",
  "notifications.column_settings.alert": "Үстел ескертпелері",
  "notifications.column_settings.follow": "Жаңа оқырмандар:",
  "notifications.column_settings.follow_request": "Жазылуға жаңа сұранымдар:",
  "notifications.column_settings.mention": "Аталымдар:",
  "notifications.column_settings.poll": "Нәтижелері:",
  "notifications.column_settings.push": "Push ескертпелер",
  "notifications.column_settings.reblog": "Бөлісулер:",
  "notifications.column_settings.show": "Бағанда көрсет",
  "notifications.column_settings.sound": "Дыбысын қос",
  "notifications.column_settings.status": "New toots:",
  "notifications.filter.all": "Барлығы",
  "notifications.filter.boosts": "Бөлісулер",
  "notifications.filter.follows": "Жазылулар",
  "notifications.filter.mentions": "Аталымдар",
  "notifications.filter.polls": "Сауалнама нәтижелері",
  "notifications.group": "{count} ескертпе",
  "poll.closed": "Жабық",
  "poll.refresh": "Жаңарту",
  "poll.total_people": "{count, plural, one {# адам} other {# адам}}",
  "poll.total_votes": "{count, plural, one {# дауыс} other {# дауыс}}",
  "poll.vote": "Дауыс беру",
  "poll.voted": "Бұл сұраққа жауап бердіңіз",
  "poll_button.add_poll": "Сауалнама қосу",
  "poll_button.remove_poll": "Сауалнаманы өшіру",
  "privacy.change": "Құпиялылықты реттеу",
  "privacy.public.short": "Ашық",
  "refresh": "Жаңарту",
  "relative_time.days": "{number}күн",
  "relative_time.hours": "{number}сағ",
  "relative_time.just_now": "жаңа",
  "relative_time.minutes": "{number}мин",
  "relative_time.seconds": "{number}с",
  "relative_time.today": "бүгін",
  "reply_indicator.cancel": "Қайтып алу",
  "report.forward": "Жіберу {target}",
  "report.forward_hint": "Бұл аккаунт басқа серверден. Аноним шағым жібересіз бе?",
  "report.placeholder": "Қосымша пікірлер",
  "report.submit": "Жіберу",
  "report.target": "Шағымдану {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "Іздеу",
  "search_results.hashtags": "Хэштегтер",
  "search_results.statuses": "Жазбалар",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_account": "@{name} үшін модерация интерфейсін аш",
  "status.admin_status": "Бұл жазбаны модерация интерфейсінде аш",
  "status.block": "Бұғаттау @{name}",
  "status.bookmark": "Бетбелгі",
  "status.cancel_reblog_private": "Бөліспеу",
  "status.cannot_reblog": "Бұл жазба бөлісілмейді",
  "status.copy": "Жазба сілтемесін көшір",
  "status.delete": "Өшіру",
  "status.detailed_status": "Толық пікірталас көрінісі",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "Тағы әкел",
  "status.media_hidden": "Жабық медиа",
  "status.mention": "Аталым @{name}",
  "status.more": "Тағы",
  "status.mute": "Үнсіз @{name}",
  "status.mute_conversation": "Пікірталасты үнсіз қылу",
  "status.open": "Жазбаны ашу",
  "status.pin": "Профильде жабыстыру",
  "status.read_more": "Әрі қарай",
  "status.reblog": "Бөлісу",
  "status.reblogged_by": "{name} бөлісті",
  "status.reblogs.empty": "Бұл жазбаны әлі ешкім бөліспеді. Біреу бөліскен кезде осында көрінеді.",
  "status.redraft": "Өшіру & қайта қарастыру",
  "status.remove_bookmark": "Бетбелгілерден алып тастау",
  "status.reply": "Жауап",
  "status.replyAll": "Тақырыпқа жауап",
  "status.report": "Шағым @{name}",
  "status.sensitive_warning": "Нәзік контент",
  "status.share": "Бөлісу",
  "status.show_less_all": "Бәрін аздап көрсет",
  "status.show_more_all": "Бәрін толығымен",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.unmute_conversation": "Пікірталасты үнсіз қылмау",
  "status.unpin": "Профильден алып тастау",
  "tabs_bar.home": "Басты бет",
  "tabs_bar.notifications": "Ескертпелер",
  "time_remaining.days": "{number, plural, one {# күн} other {# күн}}",
  "time_remaining.hours": "{number, plural, one {# сағат} other {# сағат}}",
  "time_remaining.minutes": "{number, plural, one {# минут} other {# минут}}",
  "time_remaining.moments": "Қалған уақыт",
  "time_remaining.seconds": "{number, plural, one {# секунд} other {# секунд}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Тренд тақырыптар",
  "ui.beforeunload": "Mastodon желісінен шықсаңыз, нобайыңыз сақталмайды.",
  "upload_area.title": "Жүктеу үшін сүйреп әкеліңіз",
  "upload_button.label": "Медиа қосу (JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_error.limit": "Файл жүктеу лимитінен асып кеттіңіз.",
  "upload_error.poll": "Сауалнамамен бірге файл жүктеуге болмайды.",
  "upload_form.edit": "Түзету",
  "upload_progress.label": "Жүктеп жатыр...",
  "video.close": "Видеоны жабу",
  "video.download": "Файлды түсіру",
  "video.exit_fullscreen": "Толық экраннан шық",
  "video.expand": "Видеоны аш",
  "video.fullscreen": "Толық экран",
  "video.hide": "Видеоны жасыр",
  "video.pause": "Пауза",
  "video.play": "Қосу"
}
